module.exports = __webpack_public_path__ + "static-m/img/default_auther.9439c1f6.png";